module.exports = __webpack_public_path__ + "static/media/compare_destinations.47505689.png";